import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/productcategories'

export default {
  getCategory(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  getList(parent_id = '', page, per_page, search = '', type = '') {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/list`, {
      parent_id,
      page,
      per_page,
      search,
      type
    })
  },
  edit(id, category) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/${id}`, category);
  },
  create(category) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}`, category);
  },
  delete(id) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
}
